import React from "react";

import { Box } from "../../UI/Box";
import { COLOR_PICKLE_BLUEWOOD } from "../../constants/styles";

interface IProps {
  endAdornment?: React.ReactNode;
  px?: number
  py?: number;
}

export const TableHeader: React.FC<IProps> = (props) => (
  <Box
    height={56}
    bgcolor={COLOR_PICKLE_BLUEWOOD}
    alignItems="center"
    display="flex"
    px={props.px ? props.px : 2}
    py={props.py}
    borderRadius="3px 3px 0px 0px"
  >
    {props.children}
    {props.endAdornment}
  </Box>
);
